import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { ModalHtmlPreviewComponent } from "@sharedV11/components/dialogs/modal-html-preview/modal-html-preview.component";
import { ListadoEtiqueta, ListadoEnlacesMenu, ListaListado, LstEnlacesMenu, TraerDatosListaFilters, TraerDatosLista, TransformedListadoyKeyValues, Mensaje } from "@sharedV11/models";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { MicroserviceService } from "@sharedV11/services/microservices/microservice.service";
import { ListaIdiomaMicroService } from "@sharedV11/services/microservices/model";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-edit-categorias",
  templateUrl: "./edit-impresion-online.component.html",
  styleUrls: ["./edit-impresion-online.component.scss"],
})
export class EditImpresionOnlineComponent implements OnInit {
  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;
  @Input() otherProps: TransformedListadoyKeyValues;

  translation: any;

  editRegistroForm: FormGroup;

  // Enlaces Menu
  enlacesMenuSinAsignar:LstEnlacesMenu[] = [];
  enlacesMenuAsignados: LstEnlacesMenu[] = [];
  selectedEnlaceMenuId = '';

  // Grupos Internet
  gruposInternetSinAsignar: TraerDatosLista[] = [];
  gruposInternetAsignados: TraerDatosLista[] = [];
  gruposInternetSinAsignarMap: Map<string, TraerDatosLista[]> = new Map()
  gruposInternetAsignadosMap: Map<string, TraerDatosLista[]> = new Map()

  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  tipoImpresion: { value: number, name: string }[] = [ 
    { value: 0, name: this.translator.instant('TipoImpresionPor_0') } ,
    { value: 1, name: this.translator.instant('TipoImpresionPor_1') },
    { value: 2, name: this.translator.instant('TipoImpresionPor_2') },
    { value: 3, name: this.translator.instant('TipoImpresionPor_3') },
    { value: 4, name: this.translator.instant('TipoImpresionPor_4') },
  ] 

  fiecheros: string[] = [];
  etiquetas: ListadoEtiqueta[] = [];
  etiquetasFiltredByIdioma: ListadoEtiqueta[] = [];
  idiomasDeEtiquetas: Pick<ListaIdiomaMicroService, 'nombre' | 'codIdioma'>[] = [];
  idiomasCacheMap = new Map();
  
  htmlFromListado = "";
  formValues: ListaListado;
  modifiedListado: ListaListado;

  pdfImage = '[[PDFDATA_IMAGEN';
  pdfLogo = '[[PDFDATA_LOGO';

  constructor(
    private fb: FormBuilder,
    private translator: Translator,
    private panelService: PanelService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private conectarApiService: ConectarApiService,
    private microService: MicroserviceService,
    private dialog: MatDialog,
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    this.initializeTranslate();
    this.initializeFormWithoutData();
    this.getIdiomas().then(() => {
      this.manageForm(this.pkId, this.mode);
      this.valuedChanged();
    });
  }

  initializeFormWithoutData() {
    this.editRegistroForm = this.fb.group({
      pkId: [""],
      Nombre: ["", [Validators.required, Validators.pattern(/^[A-Za-z ]+$/)]],
      Fichero: ["", Validators.required],
      TipoImpresion: ["", Validators.required],
      Notas: [""],
      PageSize: [""],
      MargenLeft: [0, [Validators.maxLength(4), Validators.pattern(/^[0-9]*$/)]],
      MargenRight: [0, [Validators.maxLength(4), Validators.pattern(/^[0-9]*$/)]],
      MargenTop: [0, [Validators.maxLength(4), Validators.pattern(/^[0-9]*$/)]],
      MargenBottom: [0, [Validators.maxLength(4), Validators.pattern(/^[0-9]*$/)]],
      EnlacesMenu: [null, Validators.required],
      IdiomaDeEtiqueta: [''],
      Etiquetas: this.fb.array([])
    });
  }

  manageForm(pkId, mode) {
    if (mode == "I") {
      this.getEnlacesMenu();
      this.loadFicheros();
      this.formValues = this.editRegistroForm.value;
      this.loading = false;
    }
    if (pkId) {
      this.findListadoByPkId(pkId);
    }
  }

  updateFormValues(listado: ListaListado) {
    if (listado) {
      this.editRegistroForm.patchValue({
        pkId: listado.pkId,
        Nombre: listado.Nombre,
        Fichero: listado.Fichero,
        TipoImpresion: listado.TipoImpresion,
        Notas: listado.Notas,
        PageSize: listado.PageSize,
        MargenLeft: listado.MargenLeft,
        MargenRight: listado.MargenRight,
        MargenTop: listado.MargenTop,
        MargenBottom: listado.MargenBottom,
        EnlacesMenu: listado.EnlacesMenu,
        Etiquetas: listado.Etiquetas
      })

      this.getEnlacesMenu().then(() => {
        this.setEnlacesMenuFromListado(listado?.EnlacesMenu);
      });

      this.fiecheros.push(listado.Fichero)

      if (listado.Fichero && listado.Etiquetas) {
        this.setEtiquetas(listado.Etiquetas ?? []);
        this.addEtiquetaOnControl();
      }

      if (listado.Fichero && (!listado.Etiquetas || !listado.Etiquetas?.length)) {
        this.getEtiquetasByFichero(listado.Fichero);
      }
    }
  }

  setEnlacesMenuFromListado(enlacesMenu: ListadoEnlacesMenu[]): void {
    if (this.enlacesMenuSinAsignar.length && enlacesMenu?.length) {
      enlacesMenu.forEach((ownEm) => {
        const getOwnEm = this.enlacesMenuSinAsignar.find((allEm) => allEm.pkId === `${ownEm.EnlaceMenuId}`);

        if (getOwnEm) {
          this.enlacesMenuAsignados.push(getOwnEm);
        }
      })
    }
  }

  removeEtiqueta(index: number): void {
    this.etiquetasArrayControl.removeAt(index);
  }

  valuedChanged() {
    this.editRegistroForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (this.formValues) {
        this.panelService.setDiscardChanges(false);

        if (JSON.stringify(value) === JSON.stringify(this.formValues)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }

  submit() {
    this.editRegistroForm.markAllAsTouched();

    const formValues: ListaListado = this.editRegistroForm.value;
    formValues.MargenLeft = formValues.MargenLeft || 0;
    formValues.MargenRight = formValues.MargenRight || 0;
    formValues.MargenTop = formValues.MargenTop || 0;
    formValues.MargenBottom = formValues.MargenBottom || 0;

    // const getPreparedEnlacesMenuWithGi = this.prepareEnlacesMenuForIns();

    // formValues.EnlacesMenu = getPreparedEnlacesMenuWithGi;
    delete formValues['IdiomaDeEtiqueta'];

    if (this.editRegistroForm.valid && this.enlacesMenuAsignados.length) {
      this.manageApi(formValues, this.mode);
    }
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  save() {
    this.loading = false;
    this.panelService.setDiscardChanges(true);

    this.panelService.setSavePanel(null);
  }

  discard() {
		switch (this.mode) {
			case "I":
				this.gruposInternetAsignadosMap.clear();
				this.gruposInternetSinAsignarMap.clear();
        this.gruposInternetAsignados = [];
        this.gruposInternetSinAsignar = [];
        this.enlacesMenuAsignados = [];
        this.selectedEnlaceMenuId = "";
        this.etiquetasArrayControl.reset();
        this.etiquetasArrayControl.clear();
				break;
			case "U":
			case "D":
          this.gruposInternetAsignadosMap.clear();
          this.gruposInternetSinAsignarMap.clear();
          this.gruposInternetAsignados = [];
          this.gruposInternetSinAsignar = [];
          this.enlacesMenuAsignados = [];
          this.selectedEnlaceMenuId = "";
				break;

			default:
				break;
		}

    this.updateFormValues(this.formValues);
    this.editRegistroForm.markAllAsTouched();
  }

  onGuiaVisual(): void {
    const dialogRef = this.dialog.open(ModalHtmlPreviewComponent, {
      data: { html: this.htmlFromListado },
      width: '90vw',
      height: '90vh'
    })
  }

  manageApi(formValues: ListaListado, mode) {
    this.loading = true;
    switch (mode) {
      case "I":
        //insert
        formValues.pkId = 0;
        this.InsFormValues(formValues);
        break;
      case "U":
        //update
        this.InsFormValues(formValues);

        break;
      case "D":
        //duplicate
        formValues.pkId = 0;
        this.InsFormValues(formValues);

        break;

      default:
        break;
    }
  }
  
  InsFormValues(formValues: ListaListado) {
    this.conectarApiService.insUpdListadosDeImpresionOnline(formValues)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.nextWindow(response);
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  nextWindow(response: any) {
    const err = this.existErrors();
    if (!this.existErrors()) {
      this.save();
      this.destroy();
      this.showErrorMessageOnSnackBar(response.Mensajes, 'InsertarActualizarListadosError');
    }
  }

  showErrorMessageOnSnackBar(mensajes: Mensaje[], serviceName?: string): void {
    if (mensajes.length > 0) {
      mensajes.forEach((element) => {
        const description = serviceName ? this.translator[`${serviceName}${element.CodigoMensaje}`] : element.DescripcionMensaje;

        this.snackvar_service.openSnackBar(
          description ?? element.DescripcionMensaje,
          "",
          "red-snackbar",
          serviceName ? "" : element.CodigoMensaje
        );
      });
    } else {
      this.snackvar_service.openSnackBar(
        this.translation["MensajeSuccessSnackBar"],
        "",
        "green-snackbar"
      );
    }
  }

  getIdiomaDeEtiqueta(idioma: MatSelectChange): void {
    this.etiquetasFiltredByIdioma = this.etiquetas.filter(etiqueta => etiqueta.Idioma === idioma.value);

    this.addEtiquetaOnControl();
  }

  getSelectedEnlaceMenu(item: { _id: string; _name?: string; }): void {
    this.selectedEnlaceMenuId = item._id;

    const getEnlaceMenuPorItem = this.enlacesMenuSinAsignar.find((em) => em.pkId === item._id);

    this.getGruposInternet(getEnlaceMenuPorItem.pkId, {
      NombreCampo: 'ListaIds',
      FiltroCampo: getEnlaceMenuPorItem?.GruposInternetAsociados
    }).then(() => {
      this.getGruposInternetAsignadosFromCache(this.selectedEnlaceMenuId);
    });

  }

  getGruposInternetAsignadosFromCache(enlaceMenuId?: string): void {
    const enlacesMenuControlValue = this.editRegistroForm.controls['EnlacesMenu'].value as ListadoEnlacesMenu[];

    if (enlacesMenuControlValue?.length && this.gruposInternetSinAsignar?.length && !this.gruposInternetAsignadosMap.has(this.selectedEnlaceMenuId)) {
      const getGiBySelectedEm = enlacesMenuControlValue.find((em) => em.EnlaceMenuId === +enlaceMenuId)?.GruposInternet ?? [];

      this.gruposInternetAsignados =  getGiBySelectedEm?.length ? this.gruposInternetSinAsignar.filter(gi => getGiBySelectedEm.includes(+gi.Id)) : [];
      this.gruposInternetAsignadosMap.set(enlaceMenuId, this.gruposInternetAsignados);
    }


    if (this.selectedEnlaceMenuId && this.gruposInternetAsignadosMap.has(this.selectedEnlaceMenuId)) {
      this.gruposInternetAsignados = this.gruposInternetAsignadosMap.get(this.selectedEnlaceMenuId);
    }
  }

   getEmitedMovedGruposInternet(): void {
    if (this.selectedEnlaceMenuId) {
      this.gruposInternetAsignadosMap.set(this.selectedEnlaceMenuId, this.gruposInternetAsignados);

      const emControlValue = this.editRegistroForm.controls['EnlacesMenu']?.value as ListadoEnlacesMenu[];
      const updatedEmWithGi = emControlValue.map((em) => ({
        ...em,
        GruposInternet: em.EnlaceMenuId === +this.selectedEnlaceMenuId ? this.gruposInternetAsignadosMap.get(this.selectedEnlaceMenuId)?.map((gi) => +gi?.Id) ?? [] : em.GruposInternet
      }))

      this.editRegistroForm.controls['EnlacesMenu'].setValue(updatedEmWithGi);
    }
  }

  resetGruposInternetControlValue(): void {
    this.editRegistroForm.controls['GruposInternet']?.setValue(new Map());
  }

  getEmitedMovedEnlacesMenu(): void {
    if (!this.enlacesMenuAsignados.length) {
      this.selectedEnlaceMenuId = '';
      this.gruposInternetAsignados = [];
      this.gruposInternetSinAsignar = [];
      this.gruposInternetAsignadosMap.clear();
      this.resetGruposInternetControlValue();
      this.editRegistroForm.get('EnlacesMenu').setValue(null);
    } else {
      const emListado: ListadoEnlacesMenu[] = this.enlacesMenuAsignados.map((em) => 
        {
          return { 
            EnlaceMenuId: +em.pkId, 
            GruposInternet: this.gruposInternetAsignadosMap.get(em.pkId)?.map((gi) => +gi?.Id) ?? []
          }
        });

      this.editRegistroForm.get('EnlacesMenu').setValue(emListado);
    }

  }

  onChangeFichero(event: MatSelectChange): void {
    if (event.value) {
      this.getEtiquetasByFichero(event.value);
    }
  }

  addEtiquetaOnControl(): void {
    if (this.etiquetasFiltredByIdioma?.length) {
      this.etiquetasArrayControl.clear();

      this.etiquetasFiltredByIdioma.forEach(etiqueta => {
        this.etiquetasArrayControl.push(
          this.fb.group({
            Idioma: [etiqueta.Idioma],
            Name: [etiqueta.Name],
            Value: [etiqueta.Value]
          })      
        )        
      })
    }
  }

  async loadFicheros() {
    try {
      const listadoResponse = await this.conectarApiService.getListadosDeImpresionOnline(null, [{ name: 'Fichero', value: "TODOS" }]).toPromise()
      
      if (listadoResponse.DatosResult) {
        this.fiecheros = listadoResponse.DatosResult.Plantillas;
      } else {
        this.fiecheros = [];
      }

      if (listadoResponse?.Mensajes?.length) {
        this.showErrorMessageOnSnackBar(listadoResponse.Mensajes, 'GetListados');
      }

    } catch (error) {
      console.info(`While loading listados de impresion online happend error ${error}`);
      this.fiecheros = [];
    }
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };
  }  

  async findListadoByPkId(pkId) {
    try {
      const listadoResponse = await this.conectarApiService.getListadosDeImpresionOnline(null, [{ name: 'Id', value: pkId }, { name: 'Fichero', value: this.otherProps?.Fichero ?? "" }]).toPromise();

      if (listadoResponse.DatosResult?.ListaListados?.length) {
        this.updateFormValues(listadoResponse.DatosResult.ListaListados[0]);

        this.formValues = this.editRegistroForm.value;
        this.htmlFromListado = listadoResponse.DatosResult.HTML ?? "";
        this.loading = false;
      }

      if (listadoResponse?.Mensajes?.length) {
        this.showErrorMessageOnSnackBar(listadoResponse.Mensajes, 'GetListados');
      }

    } catch (error) {
      console.info(`While loading listados de impresion online happend error ${error}`);
    }
  }

  async getIdiomas(): Promise<void> {
    try {
      if (this.idiomasCacheMap.has('idiomas')) {
        this.idiomasDeEtiquetas = this.idiomasCacheMap.get('idiomas');
        this.editRegistroForm.controls['IdiomaDeEtiqueta'].setValue(this.idiomasDeEtiquetas[0]?.codIdioma ?? '');
      } else {
        const response = await this.microService.getIdiomasWithMicroservice({ activo: '1' }).toPromise();

        if (response?.listaIdiomas?.length) {
          this.idiomasDeEtiquetas = response.listaIdiomas.map((idiomas) => ({ nombre: idiomas.nombre, codIdioma: idiomas.codIdioma }));
          this.editRegistroForm.controls['IdiomaDeEtiqueta'].setValue(this.idiomasDeEtiquetas[0]?.codIdioma ?? '');
          this.idiomasCacheMap.set('idiomas', this.idiomasDeEtiquetas);
        } else {
          this.idiomasDeEtiquetas = [];
          this.idiomasCacheMap.delete('idiomas');
        }
      }
    } catch (error) {
      console.info(`While loading idiomas happend error ${error}`);
      this.idiomasDeEtiquetas = [];
      this.idiomasCacheMap.delete('idiomas');
    }
  }  

  async getGruposInternet(enlaceMenuId: string, filters: TraerDatosListaFilters) {
    try {

      if (this.gruposInternetSinAsignarMap.has(enlaceMenuId)) {
        this.gruposInternetSinAsignar = this.gruposInternetSinAsignarMap.get(enlaceMenuId);
        this.gruposInternetAsignados = this.gruposInternetAsignadosMap.get(enlaceMenuId);
      } else {
        const response = await this.conectarApiService.TraerDatosListasAsync('gruposinternet', filters).toPromise();
        this.gruposInternetSinAsignar = response?.DatosListas || [];
        this.gruposInternetSinAsignarMap.set(enlaceMenuId, this.gruposInternetSinAsignar);
      }

    } catch (error) {
      console.info(`While loading grupos internet happend error ${error}`);
      this.gruposInternetSinAsignar = [];
      this.gruposInternetSinAsignarMap.delete(enlaceMenuId);
    }
  }

  async getEtiquetasByFichero(value: string): Promise<void> {
    if (value) {
      try {
        const listadoResponse = await this.conectarApiService.getListadosDeImpresionOnline(null, [{ name: 'Fichero', value }]).toPromise();
        if (listadoResponse.DatosResult) {
          this.htmlFromListado = listadoResponse.DatosResult.HTML ?? "";
        }

        if (listadoResponse.DatosResult && listadoResponse.DatosResult?.ListaListados?.length) {
          const etiquetas =  listadoResponse.DatosResult.ListaListados.length > 1 ? 
            listadoResponse.DatosResult.ListaListados.find((listado) => listado.pkId === +this.selectedEnlaceMenuId)?.Etiquetas ?? [] : 
            listadoResponse.DatosResult.ListaListados[0]?.Etiquetas ?? [];
          
          this.setEtiquetas(etiquetas);
          this.addEtiquetaOnControl();
        } else {
          this.etiquetas = [];
          this.etiquetasFiltredByIdioma = [];
        }

        if (listadoResponse?.Mensajes?.length) {
          this.showErrorMessageOnSnackBar(listadoResponse.Mensajes, 'GetListados');
        }
      } catch (error) {
        console.info(`While loading listados de impresion online happend error ${error}`);
        this.etiquetas = [];
        this.etiquetasFiltredByIdioma = [];
      }
    }
  }

  async getEnlacesMenu(): Promise<void> {
    try {
      const enlacesMenuResponse = await this.conectarApiService.getEnlacesMenu().toPromise();
      this.enlacesMenuSinAsignar = enlacesMenuResponse?.DatosResult?.LstEnlacesMenu || []
    } catch (error) {
      console.info(`While loading enlaces menu happend error ${error}`);
    }
  }

  setEtiquetas(etiquetas: ListadoEtiqueta[]): void {
    this.etiquetas = etiquetas;
    this.etiquetasFiltredByIdioma = 
      this.etiquetas?.length && this.editRegistroForm.controls['IdiomaDeEtiqueta']?.value ? 
      this.etiquetas.filter((etiqueta) => etiqueta.Idioma === this.editRegistroForm.controls['IdiomaDeEtiqueta']?.value) : [];
  }

  setEtiquetaImageControlValue(imageBase64: string, index: number): void {
    this.etiquetasArrayControl.controls[index].get('Value').setValue(imageBase64);
  }

  existErrors() {
    return this.editRegistroForm.get("pkId").errors ||
      this.editRegistroForm.get("Nombre").errors ||
      this.editRegistroForm.get("Fichero").errors ||
      this.editRegistroForm.get("TipoImpresion").errors ||
      this.editRegistroForm.get("MargenLeft").errors ||
      this.editRegistroForm.get("MargenRight").errors ||
      this.editRegistroForm.get("MargenTop").errors ||
      this.editRegistroForm.get("MargenBottom").errors ||
      this.editRegistroForm.get("EnlacesMenu").errors ||
      this.etiquetasArrayControl.controls.some((control) => control.errors !== null)
      ? true
      : false;
  }

  get etiquetasArrayControl(): FormArray {
    return this.editRegistroForm.get('Etiquetas') as FormArray;
  }

  get etiquetasControlTextError(): string {
    return this.translation['CampoRequerido'];
  }

  isEtiquetaArrayControlTouched(index: number, filed: string): boolean {
    const control = this.etiquetasArrayControl.controls[index].get(filed);

    return control.invalid && (control.touched || control.dirty);
  }

  getErrorMessage(field: string) {
    const control = this.editRegistroForm.get(field);
    let errorMessage = 'Error'

    if (control && control.errors) {
      if (control.errors.required && field === 'EnlacesMenu') {
        return this.translation['AlMenosUnEnlaceMenu']
      }

      if (control.errors.required) {
        return this.translation["CampoRequerido"];
      }

      switch (field) {
        case "Nombre":
          if (control.hasError("pattern")) {
            errorMessage = this.translation["SoloLetras"];
          }
          break;
        
        case "MargenLeft":
        case "MargenRight":
        case "MargenTop":
        case "MargenBottom":
          if (control.hasError("pattern")) {
            errorMessage = this.translation["SoloNumeros"];
          }

          if (control.errors.maxlength) {
            errorMessage = `${this.translation['NumericoDeMaximoDigitos']} 4`
          }
          break;

        default:
          break;
      }
    }

    return errorMessage;
  }

  validateFields(field: string) {
    return this.isValidAnyField(field);
  }

  isValidAnyField(field: string) {
    let fc_pv = this.editRegistroForm.controls;
    return fc_pv[field].errors != null || fc_pv[field].invalid ? true : false;
  }
}
